module.exports = __webpack_public_path__ + "img/logo_notification.4a466b98.png";